import React, { useEffect, useContext } from 'react';
import { store as reportsStore } from '../../reducer';
import { makeStyles } from '@material-ui/core/styles';
import { store } from './reducer';
import List from './List';
import Total from 'components/Total/Total';
import { toFA } from 'fns/toFA';
import { formatNumber } from 'fns';
import { toEN } from 'fns';
import { rond } from 'fns';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const CustomCommission = () => {
  const classes = useStyles();
  const { dispatch: reportsDispatch, showMessage, showError } = useContext(
    reportsStore
  );
  const { Provider } = store;
  const { id } = useParams();
  const { data } = useQuery(['customCommission', window.location.search, id]);

  useEffect(() => {
    reportsDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش  کاربر',
        category: 'جهت گزارش پورسانت‌های کاربر',
      },
    });
  }, []);

  return (
    <Provider
      value={{
        showMessage,
        showError,
      }}
    >
      <div className={classes.root}>
        <List />
        <div
          className="d-flex"
          style={{ gap: 10, position: 'sticky', bottom: 0 }}
        >
          <Total
            title={'جمع کل شرکت: '}
            backgroundColor={'purple'}
            total={toFA(
              formatNumber(toEN(rond(data?.footabTotalCommission)))
            )}
          />
          <Total
            total={toFA(
              formatNumber(toEN(rond(data?.userTotalCommission)))
            )}
            title={'جمع کل متعلقه: '}
            backgroundColor={'yellow'}
          />
        </div>
      </div>
    </Provider>
  );
};

export default React.memo(CustomCommission);
